var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('img',{staticStyle:{"width":"100vw","height":"auto"},attrs:{"src":"https://matripe.oss-cn-beijing.aliyuncs.com/bcSVG/zhuchangtongDetail.png?timestamp=1741414940001","alt":""}})])
}]

export { render, staticRenderFns }